import { ConfigurationError } from "./errors-CEDWDXew.js";
import { USER_AGENT } from "./version-Dl3bNTAd.js";
import { createOpenAI } from "@ai-sdk/openai";

//#region src/internal/agents/azure-openai-provider.ts
const DEFAULT_OPENAI_MODEL = "gpt-5";
let configuredBaseUrl;
function setAzureOpenAIBaseUrl(baseUrl) {
	configuredBaseUrl = baseUrl;
}
function hasAzureDeploymentPath(baseUrl) {
	const pathname = new URL(baseUrl).pathname.replace(/\/+$/, "");
	return /\/openai\/deployments\/[^/]+$/i.test(pathname);
}
function hasAzureV1Path(baseUrl) {
	const pathname = new URL(baseUrl).pathname.replace(/\/+$/, "");
	return /\/openai\/v1$/i.test(pathname);
}
function getAzureOpenAIApiSurface() {
	if (!configuredBaseUrl) throw new ConfigurationError("Provider \"azure-openai\" requires --openai-base-url to target an Azure OpenAI endpoint.");
	if (hasAzureV1Path(configuredBaseUrl)) return "responses";
	if (hasAzureDeploymentPath(configuredBaseUrl)) return "chat-completions";
	throw new ConfigurationError("Provider \"azure-openai\" requires an Azure v1 base URL ending in /openai/v1 or a deployment URL ending in /openai/deployments/<deployment>.");
}
function getAzureOpenAIApiVersion() {
	const apiVersion = process.env.OPENAI_API_VERSION?.trim();
	return apiVersion && apiVersion.length > 0 ? apiVersion : void 0;
}
function createAzureOpenAIFetch(baseUrl) {
	const apiVersion = getAzureOpenAIApiVersion();
	const shouldAppendApiVersion = apiVersion !== void 0 && hasAzureDeploymentPath(baseUrl);
	return async (input, init) => {
		const requestUrl = input instanceof Request ? new URL(input.url) : new URL(input instanceof URL ? input.href : input.toString());
		if (shouldAppendApiVersion) requestUrl.searchParams.set("api-version", apiVersion);
		const headers = new Headers(input instanceof Request ? input.headers : void 0);
		if (init?.headers) for (const [key, value] of new Headers(init.headers).entries()) headers.set(key, value);
		if (process.env.OPENAI_API_KEY) headers.set("api-key", process.env.OPENAI_API_KEY);
		if (input instanceof Request) return fetch(new Request(requestUrl.toString(), input), {
			...init,
			headers
		});
		return fetch(requestUrl.toString(), {
			...init,
			headers
		});
	};
}
function getAzureOpenAIModel(model) {
	if (!configuredBaseUrl) throw new ConfigurationError("Provider \"azure-openai\" requires --openai-base-url to target an Azure OpenAI endpoint.");
	const apiSurface = getAzureOpenAIApiSurface();
	const modelId = model ?? (process.env.OPENAI_MODEL || DEFAULT_OPENAI_MODEL);
	const factory = createOpenAI({
		baseURL: configuredBaseUrl,
		headers: { "User-Agent": USER_AGENT },
		name: "azure-openai",
		fetch: createAzureOpenAIFetch(configuredBaseUrl)
	});
	if (apiSurface === "chat-completions") return factory.chat(modelId);
	return factory(modelId);
}

//#endregion
export { getAzureOpenAIApiSurface, getAzureOpenAIModel, setAzureOpenAIBaseUrl };
//# sourceMappingURL=azure-openai-provider-BNAjkBmg.js.map